import React, { PureComponent } from "react";
import PageLink from "../../Page/PageLink";
import Footer from "../../Footer/Footer";
import WorkflowCompatibility from "../../../components/Workflow/WorkflowCompatibility";

class NL_Record_audit_delete extends PureComponent {
  render() {
    return (
      <div className="row" id="nl_record_audit_delete">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>NL.Record.audit_delete</h2>
              <p>
                NL.Record.audit_delete allows you to clear the audit record
                history.
              </p>
              <WorkflowCompatibility front={false} back={true} />
              <h3>Options</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Option</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">age</td>
                    <td>
                      Number of days greater than 45.
                      <br />
                      <i>45 - 10,000 default is 60</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>NL.Record.audit_delete Example</h2>
              <p>
                This example deletes an monitor audit records older than 90
                days.
              </p>
              <div className="darkCode">
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">type</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonA">"</span>
                  <span className="jsonG">monitor</span>
                  <span className="jsonA">";</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">age</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonO">60</span>
                  <span className="jsonA">;</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">options</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonY">&#123; &#125;</span>
                  <span className="jsonA">;</span>
                </div>

                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonPink">NL</span>
                  <span className="jsonA">.</span>
                  <span className="nodeCode">Record</span>
                  <span className="jsonA">.</span>
                  <span className="jsDeclaration">audit_delete</span>
                  <span className="jsonY">(</span>
                  <span className="nodeCode">type</span>
                  <span className="jsonA">, </span>
                  <span className="nodeCode">age</span>
                  <span className="jsonA">, </span>
                  <span className="nodeCode">options</span>
                  <span className="jsonA">, </span>
                  <span className="jsonP">function</span>
                  <span className="jsonA">(</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">, </span>
                  <span className="jsonPink">data</span>
                  <span className="jsonA">) </span>
                  <span className="jsonA">&#123;</span>
                </div>

                <div className="i1">
                  <span className="jsonA">if (</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">) </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Failed</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA"> else </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Success</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                </div>

                <div>
                  <span className="jsonA">&#125;</span>
                  <span className="jsonY">)</span>
                  <span className="jsonA">;</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default NL_Record_audit_delete;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/NL_Record_audit_delete.js